import StepperFilePage from '@/views/restricted/repair-file-module/folder-setup/StepperFilePage.vue'
import DistributorLayout from '@/layouts/DistributorLayout.vue'
import CreateRepairFileFinalizationPage
  from '@/views/restricted/repair-file-module/folder-setup/CreateRepairFileFinalizationPage.vue'
import ShippingPage from '@/views/restricted/repair-file-module/folder-setup/ShippingPage.vue'
import RepairFileProspectAddPicturePage from '@/views/public-access/repair-module/RepairFileProspectAddPicturePage.vue'
import RepairFileProspectManufacturerOptionSelectedPage
  from '@/views/public-access/repair-module/RepairFileProspectManufacturerOptionSelectedPage.vue'

export default [
  {
    path: '/repair-file/:repairFileBoomerangId?',
    name: 'StepperFile',
    component: StepperFilePage,
    props: true,
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_ADD_REPAIR_FILE']
    }
  },
  {
    path: '/repair-file/finalization/:repairFileBoomerangId?',
    name: 'CreateRepairFileFinalization',
    component: CreateRepairFileFinalizationPage,
    props: true,
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_ADD_REPAIR_FILE']
    }
  },
  {
    path: '/repair-file/shipping/:repairFileBoomerangId',
    name: 'Shipping',
    component: ShippingPage,
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_ADD_REPAIR_FILE']

    }
  },
  {
    path: '/public/repair-prospect/add-product-picture',
    name: 'RepairFileProspectAddPicturePage',
    component: RepairFileProspectAddPicturePage,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/public/repair-prospect/manufacturer-prospect-option-select',
    name: 'RepairFileProspectManufacturerOptionSelectedPage',
    component: RepairFileProspectManufacturerOptionSelectedPage,
    meta: {
      requiresAuth: false
    }
  },
]
